module.exports = __webpack_public_path__ + "img/600.bb019685.svg";